import React from 'react'
import PropTypes from 'prop-types'

import { StyledContainer, StyledAnimation } from './styles'

const Spinner = ({ isLoading, style = {} }) =>
  isLoading && (
    <StyledContainer style={style}>
      <StyledAnimation />
    </StyledContainer>
  )

Spinner.propTypes = {
  isLoading: PropTypes.bool,
  style: PropTypes.object,
}

export default Spinner
